import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BookingService } from 'app/modules/bookings/services/booking.service';
import { AppSettings } from '../../app.settings';
import { GoogleRoute } from '../../models/google-route.model';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { StorageService } from '../../services/storage.service';
import { UiService } from '../../services/ui.service';
import { UserCommonService } from '../../services/user-common.service';
import { ConfirmationService } from 'primeng/api';
import * as momentImported from 'moment';
const moment = (momentImported as any).default || momentImported;
declare const google: any;

@Component({
  selector: 'app-assign-driver-map',
  templateUrl: './assign-driver-map.component.html',
  styleUrls: ['./assign-driver-map.component.scss'],
  providers: [DatePipe]
})
export class AssignDriverMapComponent implements OnInit {

  @Input() bookingId: any = '';
  @Input() dedicatedTourDaywiseDataId: any = null;
  @Output() sideBarHide: EventEmitter<any> = new EventEmitter();

  listMapOptions = [
    { icon: 'pi pi-map', label: ' Map', value: false },
    { icon: 'pi pi-list', label: ' List', value: true }
  ];

  options = {
    center: AppSettings.MAP_OPTIONS_POSITION,
    zoom: 14,
    zoomControl: true,
    streetViewControl: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControl: true,
    styles: [{ "featureType": "poi", "stylers": [{ "visibility": "off" }] }],
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.LEFT_BOTTOM,
    },
  };

  url = '/secure/tour/list/data?type=ACTIVE&subServiceType=';
  searchPlaceHolder = 'Press enter to search';
  filterButtonClass = 'filter-btn-apply';
  currentStatus = AppSettings.CURRENT_DRIVER_STATUS;
  sortTypeOptions = AppSettings.DRIVER_ASSIGN_SORT;
  radiusOption = AppSettings.RADIUS_LIST;
  viewDaysBooking: boolean = false;
  showThirdPartyList: Boolean = false;
  selectedTab: boolean = true;
  value: any = true;
  filterApplied = false;
  toThirdParty = false;
  pagination: boolean = false;
  checked: boolean = false;
  isDisplayUpcommingList = false;
  driverList = [];
  records: any = [];
  columns: any = [];
  parkingLocationsOptions: any[] = [];
  teamsOptions: any[] = [];
  thirdPartyList = [];
  markers: any = [];
  driversResults: any = [];
  originalFilterData: any;
  selectedWatchList: any = '';
  changedFilterData: any;
  gridScrollHeight = '';
  params: any = '';
  navigateFrom: any = '';
  tourBookingInfo: any;
  passengerInfo: any;
  selectedCurrentStatus: any = '';
  selectedRadius: any = '';
  defaultOrAssignedParking = '';
  selectedparkingLocation: any;
  bookingDetail: any;
  defaultSelectedparkingLocation: any = '';
  selectedSortType: any;
  selectedTeam: any = '';
  map: any;
  searchDriverInMap: any = '';
  thirdPartEventChecked;
  datePipeString: string;
  upcomingUrl: any = '';
  driverId: any;
  marker: any;
  currentDriverStatus = '';
  infoWindow;
  infoWindow1;
  gmarkers = [];
  bindLatLongs = [];
  waypts = [];
  isAlive = true;
  fromDate: any = null;
  toDate: any = null;

  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private userCommonService: UserCommonService,
    private uiService: UiService,
    private bookingService: BookingService,
    private storageService: StorageService,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    if (this.bookingId) {
      this.initializeMap();
      this.url = `/secure/drivers/assign-trip/${this.bookingId}/list/data`;
      this.getBookingDetails();
      this.getTeamList();
      this.getParkingLocations();
      setTimeout(() => {
        this.initializeUrl();
      }, 1000);
    }
  }

  getTeamList() {
    this.commonBindingDataService.getShiftGroupList().subscribe(result => {
      this.teamsOptions = result.map(ele => ({ label: `${ele.name.length > 15 ? `${ele.name.slice(0, 15)}...` : ele.name}`, value: ele.id }));
      this.teamsOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all_teams'), value: '' });
    });
  }

  getParkingLocations() {
    if (this.userCommonService.userMetaData) {
      const defaultParkingOptions = [
        { label: 'All Driver', value: 'all_drivers' },
        { label: 'All Checked - In', value: 'all_checked_in' },
        { label: 'All Non Checked - In', value: 'all_non_checked_in' }
      ];
      this.userCommonService.userMetaData.locationCategorisList.forEach(element => {
        if (element.id === AppSettings.LOCATION_TYPES.PARKING) {
          this.commonBindingDataService.getParkingLocationsList(element.id, '').subscribe(
            (result) => {
              this.parkingLocationsOptions = result.data.map(eachLocation => (
                { label: eachLocation.displayAddress, value: eachLocation.id }
              ));
              this.parkingLocationsOptions = [...defaultParkingOptions, ...this.parkingLocationsOptions];
              this.selectedparkingLocation =
                (this.parkingLocationsOptions.length > 0) ? (this.defaultOrAssignedParking ?
                  this.defaultOrAssignedParking : this.parkingLocationsOptions[0].value) : this.defaultSelectedparkingLocation;
              this.defaultSelectedparkingLocation = this.selectedparkingLocation ? this.selectedparkingLocation : '';
            }, (error) => {
            });
        }
      });
    }
  }

  getBookingDetails() {
    this.bookingService.fetchTourBooking(this.bookingId, '', null, null).subscribe(results => {
      this.bookingDetail = results;
      this.tourBookingInfo = results.tourBookingInfo;
      this.passengerInfo = results.passengerInfo;
      this.drawRoute(this.tourBookingInfo);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR)
    });
  }

  initializeMap() {
    this.map = new google.maps.Map(document.getElementById('driver-map'), this.options);
    this.checked = this.storageService.getItem('toggleDarkAndLightMap');
    const styleControl = document.getElementById('style-selector-control') as HTMLElement;
    if (styleControl) {
      this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(styleControl);
    }

    if (this.checked == false) {
      this.map.setOptions({ styles: AppSettings.LOCATION_MAP_STYLE_DEFAULT });
      this.map.setOptions({ styles: [{ "featureType": "poi", "stylers": [{ "visibility": "off" }] }] });
    } else {
      this.map.setOptions({ styles: AppSettings.LOCATION_MAP_STYLE_DARK });
    }
  }

  toggleDarkAndLightMap(event) {
    this.checked = event.checked;
    this.storageService.setItem("toggleDarkAndLightMap", this.checked)
    if (this.checked == false) {
      this.map.setOptions({ styles: AppSettings.LOCATION_MAP_STYLE_DEFAULT });
      this.map.setOptions({ styles: [{ "featureType": "poi", "stylers": [{ "visibility": "off" }] }] });
    } else {
      this.map.setOptions({ styles: AppSettings.LOCATION_MAP_STYLE_DARK });
    }
  }

  searchDrivers() {
    if (!this.searchDriverInMap || this.searchDriverInMap.trim() == '') {
      this.applyFilter();
      return;
    }

    this.fromDate = moment(this.tourBookingInfo?.pickupDateTime).startOf('day').valueOf();
    this.toDate = moment(this.tourBookingInfo?.pickupDateTime).endOf('day').valueOf();

    let params = `?searchText=${this.searchDriverInMap}`;
    params += (`&fromDate=${this.fromDate}`);
    params += (`&toDate=${this.toDate}`);

    this.bookingService.getAssignTripDetails(this.bookingId, params).subscribe(results => {
      this.records = results.data;
      this.drawMarkers();
    })
  }

  initializeUrl() {
    this.resetFilter();
  }

  resetFilter() {
    this.fromDate = moment(this.tourBookingInfo?.pickupDateTime).startOf('day').valueOf();
    this.toDate = moment(this.tourBookingInfo?.pickupDateTime).endOf('day').valueOf();

    this.defaultSelectedparkingLocation = 'all_checked_in';
    this.selectedCurrentStatus = '';
    this.selectedSortType = AppSettings.DRIVER_ASSIGN_SORT_KEYS[0];
    this.selectedRadius = '10';
    this.selectedTeam = '';
    this.searchDriverInMap = '';
    this.applyFilter();
  }

  changeFilter(key?, val?) {
    if (!this.changedFilterData) {
      this.changedFilterData = {};
    }
    this.changedFilterData[key] = val !== undefined && val !== null ? val.toString() : '';
    this.filterApplied = true;
  }

  applyFilter() {
    if (this.searchDriverInMap && this.searchDriverInMap.trim() !== '') {
      return;
    }

    this.fromDate = moment(this.tourBookingInfo?.pickupDateTime).startOf('day').valueOf();
    this.toDate = moment(this.tourBookingInfo?.pickupDateTime).endOf('day').valueOf();

    this.params = '?';
    this.params += (`parkingLocationId=${this.defaultSelectedparkingLocation}`);
    this.params += (`&driverCurrentStatus=${this.selectedCurrentStatus}`);
    this.params += (`&listSortKey=${this.selectedSortType}`);
    this.params += (`&radiusToPickup=${this.selectedRadius}`);
    this.params += (`&shiftId=${this.selectedTeam}`);
    this.params += (`&searchText=${this.searchDriverInMap || ''}`);
    this.params += (`&fromDate=${this.fromDate}`);
    this.params += (`&toDate=${this.toDate}`);

    this.filterApplied = false;
    this.bookingService.getAssignTripDetails(this.bookingId, this.params).subscribe(results => {
      this.records = results.data;
      this.drawMarkers();
    });
  }

  setMarker1(map, location, currentDriverStatus, infoWindow,) {
    this.clearMarker();
    let icon;
    switch (currentDriverStatus) {
      case '1': // FREE Car
        icon = '/assets/images/temp/taxi_free.png';
        break;
      case '2': // BUSY Car
        icon = '/assets/images/temp/taxi_busy.png';
        break;
      case '3': // IDLE Car
        icon = '/assets/images/temp/taxi_idle.png';
        break;
      default:
        icon = '/assets/images/temp/taxi_busy.png';
        break;
    }

    this.marker = new google.maps.Marker;
    this.marker.setMap(map);
    this.marker.setIcon(icon);
    this.marker.setPosition(location);
    this.markers.push(this.marker);
    this.addListener(this.marker, infoWindow);
  }

  addListener(marker, infoWindow, record?) {
    const that = this;
    marker.addListener('click', function () {
      //  ETA API CALLING
      if (record.currentStatus === 'HIRED') {
        if (record.journeyStatus == 80 || record.journeyStatus == 90 || record.journeyStatus == 130) {
        } else {
          this.ETADataStorage = ''
          const infoWindow = new google.maps.InfoWindow({
            content: that.getMarkerContent(record),
          });
          infoWindow.open(that.map, marker);
        }
      } else {
        infoWindow.open(that.map, marker);
      }

      // END OF ETA
      if (record) {
        setTimeout(() => {
          const submit = document.getElementsByClassName(record.driverId);
          if (submit.length > 0) {
            for (let i = 0; i < submit.length; i++) {
              submit[i].addEventListener('click', function () {
                that.assignDriver(record);
              }, false);
            }
          }
        }, 1500);
      }
    });
    this.markers.push(marker);
  }

  drawRoute(data: any) {
    this.gmarkers = [];
    this.map = new google.maps.Map(document.getElementById('driver-map'), this.options);
    const origin = new google.maps.LatLng(data.sourceLatitude, data.sourceLongitude);
    const dest = new google.maps.LatLng(data.destinationLatitude, data.destinationLongitude);
    const hasStop = data.tourLocationsList && data.tourLocationsList.length > 2;
    const stop = hasStop
      ? new google.maps.LatLng(data.tourLocationsList[1].latitude, data.tourLocationsList[1].longitude)
      : null;
    const bounds = new google.maps.LatLngBounds();

    this.waypts = [];

    const locations = data.tourLocationsList || [];
    for (let route = 0; route < locations.length; route++) {
      if (locations[route].latitude && locations[route].longitude) {
        this.waypts.push({
            latitude: locations[route].latitude,
            longitude: locations[route].longitude,
          });
      }
    }

    const routeData: GoogleRoute = {
      "originLatitude": data.sourceLatitude,
      "originLongitude": data.sourceLongitude,
      "destinationLatitude": data.destinationLatitude,
      "destinationLongitude": data.destinationLongitude,
      "waypoints": this.waypts,
    }
    this.userCommonService.getGoogleMapRoute(routeData).subscribe({
      next: (result) => {
        const decodedPath = this.userCommonService.decodePolyline(result.routes[0].polyline.encodedPolyline);
        const route = new google.maps.Polyline({
          path: decodedPath,
          geodesic: true,
          strokeColor: AppSettings.strokeColor,
          strokeOpacity: AppSettings.strokeOpacity,
          strokeWeight: AppSettings.strokeWeight,
        });
        route.setMap(this.map);
      },
      error: (error) => {
        console.log('error', error);
      }
    });

    const marker1 = new google.maps.Marker({
      position: origin,
      label: 'P',
      map: this.map
    });

    this.gmarkers.push(marker1);

    if (hasStop && stop) {
      const stopMarker = new google.maps.Marker({
        position: stop,
        label: 'S',
        map: this.map
      });

      this.gmarkers.push(stopMarker);
    }

    const marker2 = new google.maps.Marker({
      position: dest,
      label: 'D',
      map: this.map
    });
    this.gmarkers.push(marker2);

    const sourceBindLatLLong = {
      lat: data.sourceLatitude,
      long: data.sourceLongitude
    }
    const destBindLatLLong = {
      lat: data.destinationLatitude,
      long: data.destinationLongitude
    }
    this.bindLatLongs.push(sourceBindLatLLong)
    this.bindLatLongs.push(destBindLatLLong);

    for (let i = 0; i < this.bindLatLongs.length; i++) {
      const latLng = new google.maps.LatLng(this.bindLatLongs[i].lat, this.bindLatLongs[i].long);
      bounds.extend(latLng);
    }
    this.map.fitBounds(bounds);

  }

  clearMarker() {
    if (this.marker) {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
      this.marker = null;
    }
  }

  drawMarkers(etaStorage?) {
    this.clearMarker();
    for (let i = 0; i < this.records.length; i++) {
      const latLng = new google.maps.LatLng(this.records[i].driverLatitude, this.records[i].driverLongitude);

      let markerIcon = '/assets/images/temp/carGrey.svg';
      if (this.records[i].driverCurrentStatus.toLowerCase() === 'available') {
        markerIcon = '/assets/images/temp/carGreen.svg';
      }

      else if (this.records[i].currentTripTourStatus == 45 || this.records[i].currentTripTourStatus == 47 || this.records[i].currentTripTourStatus == 80 || this.records[i].currentTripTourStatus == 90) {
        markerIcon = '/assets/images/temp/carRed.svg';

      }
      else if (this.records[i].currentTripTourStatus == 130) {
        markerIcon = '/assets/images/temp/carPurple.svg';
      }

      if (this.records[i].driverCurrentStatus.toLowerCase() === 'idle') {
        markerIcon = '/assets/images/temp/carGrey.svg';
      }

      if (this.records[i].taskName !== '' && this.records[i].taskName !== null) {
        markerIcon = '/assets/images/temp/carYellow.svg';
      }

      this.marker = new google.maps.Marker({
        position: latLng,
        icon: markerIcon,
        map: this.map
      });

      const infoWindow = new google.maps.InfoWindow({
        content: this.getMarkerContent(this.records[i]),
      });
      this.addListener(this.marker, infoWindow, this.records[i]);
    }
  }

  getMarkerContent(record, etaStorage?) {
    let bookingInfo = '';
    let passengerInfo = '';
    let driverInfo = '';
    let vehicleInfo = '';
    let etaInfo = '';
    let nextUpcomingInfo = '';
    let taskDetails = '';

    if (record.driverCurrentStatus) {
      bookingInfo = `
      <div class="col-12">
          <div class="grid first-box">
            <div class="blue-box">
                <span class="booking-text">Previous Upcoming : <span class="booking-id">${record.upcomingTripId ? record.upcomingTripId : "NA"}</span></span>
            </div>
              <div class="col-fixed">
              <label class="${record.driverCurrentStatus == "Available" ? 'bg-light-green trip-status' : record.driverCurrentStatus == "Busy" ? 'busy-bg-color busy-text-color' : 'default-color'}">
               ${(record.driverCurrentStatus == "Available"
          ? record.driverCurrentStatus : record.driverCurrentStatus == "Busy"
            ? (record.driverCurrentStatus + ' - ' + (record.currentTripTourStatusStr ? record.currentTripTourStatusStr : 'NA')) : record.driverCurrentStatus)}</label>
              </div>
          </div>
      </div>`
    }

    if (record.nextUpcomingTripTripId) {
      nextUpcomingInfo = `
      <div class="grid flex justify-content-start align-items-center">
        <div class="blue-box">
          <span class="booking-text pl-2">Next Upcoming : <span class="booking-id">${record.nextUpcomingTripTripId ? record.nextUpcomingTripTripId : "NA"}</span></span>
        </div>
        <span class="call-Sign-number pr-0">${record.estArrivalDateTimeAtNextUpcomingPickup ? ' |' : ''}</span>
        <div class="flex">
          <span class="call-Sign-number pr-0">${record.estArrivalDateTimeAtNextUpcomingPickup ? this.datePipe.transform(record.estArrivalDateTimeAtNextUpcomingPickup, ' HH:mm ') : 'NA'}
          <span class="call-Sign-number">(${record.estDistToReachAtNextUpcomingPickupStr})</span></span>
          </span>
        </div>
      </div>`;
    }

    if (record.taskName) {
      taskDetails = `
      <div class="grid flex justify-content-start align-items-center">
        <div class="name ml-2 mt-3 pl-0" title="${record.taskDescription ? `Task Description : ${record.taskDescription}` : ''}">Task Name : ${record.taskName}</div>
      </div>`;
    }

    if (record.currentTripId) {
      const date = new Date();
      passengerInfo = `
      <div class="col-12 p-0">
          <div class="col-12 pl-0">
              <h2 class="title">Current Driver Status</h2>
          </div>
          <div class="col-12 current-driver-status-box">
            <div title="${record.currentTripId} Drop off at ${record.currentTripDropLocationName} estimated drop off time ${(record.currentTripTourStatus == AppSettings.BOOKING_STATUS_CODES.ON_TRIP || date.getTime() > record.currentTourPickupDateTime)
          ? this.datePipe.transform(date.getTime() + record?.currentTripEtaToDropTime, 'H:mm')
          : this.datePipe.transform(record?.currentTourPickupDateTime + record?.currentTripEtaToDropTime, 'H:mm')}">
              <span class='current-driver-status-text clamp-two-line'>
                <span class='booking-number'>${record.currentTripId}</span> Drop off at
                  <span class='default'>${record.currentTripDropLocationName}</span> estimated drop off time
                    <span class='default'>${(record.currentTripTourStatus == AppSettings.BOOKING_STATUS_CODES.ON_TRIP || date.getTime() > record.currentTourPickupDateTime)
          ? this.datePipe.transform(date.getTime() + record?.currentTripEtaToDropTime, 'H:mm')
          : this.datePipe.transform(record?.currentTourPickupDateTime + record?.currentTripEtaToDropTime, 'H:mm')}
                    </span>
                </span>
            </div>
          </div>
      </div>`
    }

    if (record.driverUserCode) {
      const driverName = record?.driverName.split(' ');
      driverInfo = `
      <div class="col-6">
        <div class="col-12 pl-0">
          <h2 class="title">Driver Details <span class=${record.bookingWillCompleteInSameShiftSlot == "yes" ? 'colorGreen' : 'colorRed'}>${record.bookingWillCompleteInSameShiftSlot == "yes" ? '(On shift for pickup)' : '(Off shift for pickup)'}</span></h2>

        </div>
        <div class="col-12 driver-box">
            <div class="name" title="${record.driverName}">${driverName[0]} <span class="call-Sign-number p-0 purple">${record.driverUserCode ? `(${record.driverUserCode})` : ''}</span></div>
            <div class="padding-5px">
              <span class="call-Sign-number pr-0">${record.shiftName ? record.shiftName + ' |' : ''}</span>
              <span class='call-Sign-number p-0'>${record.currentShiftSlotStartDateTime ? this.datePipe.transform(record.currentShiftSlotStartDateTime, 'H:mm') : ''}</span>
              <span class='call-Sign-number p-0'>${record.currentShiftSlotStartDateTime && record.currentShiftSlotEndDateTime ? ' - ' : 'No Slots'}</span>
              <span class='call-Sign-number p-0'>${record.currentShiftSlotEndDateTime ? this.datePipe.transform(record.currentShiftSlotEndDateTime, 'H:mm') : ''}
            </div>
        </div>
      </div>`
    }

    if (record.vehicleCode) {
      vehicleInfo = `
      <div class="col-6">
        <div class="col-12 pl-0">
          <h2 class="title">Vehicle Details</h2>
        </div>
        <div class="col-12 driver-box">
            <div class="name">${record.vehicleCode ? record.vehicleCode : ''} ${record.capacity ? `(${record.capacity})` : ''}</div>
            <div class="padding-5px">
              <span class="call-Sign-number pr-0">${record.makeModel ? record.makeModel + ' | ' : ''}</span><span class="call-Sign-number pl-0">${record.modelName ? record.modelName : ''}</span>
            </div>
        </div>
    </div>`
    }

    if (record.etaToPickupTimeStr && record.etaToPickupDistanceStr) {
      const distanceInMiles = record.etaToPickupDistanceStr.split(' ');
      etaInfo = `<div class="col-12 p-0">
           <div class="col-12 pb-0">
               <div class="grid pb-0" style="align-items: self-end;">
                   <div>
                   <div class="col-12 pl-0">
                   <h2 class="title">ETA To Pickup</h2>
                 </div>
                       <div class="bg-light-green eta-block">
                           <span class="-min-56-km">
                           ${record.estimatedArrivalDateTimeAtPickup ? this.datePipe.transform(record.estimatedArrivalDateTimeAtPickup, ' HH:mm ') : 'NA'}
                           <span class="text-style-2">|</span> ${distanceInMiles[0]} <span class="text-style-1">${distanceInMiles[1]}</span></span>
                       </div>
                   </div>
                   <div class="col pb-0" style="text-align: end;">
                       <span class="rippleevent p-button driver-assign-btn ${record.driverId}"> Assign </span>
                   </div>
               </div>
           </div>
       </div>`
    }

    const content = `<div class="google-map-info-marker">
                        <div class="map-tooltip">
                          ${bookingInfo}
                          <div>
                          ${nextUpcomingInfo}
                          </div>
                          <div>
                          ${taskDetails}
                          </div>
                          ${passengerInfo}
                          <div class="grid">
                           ${driverInfo} ${vehicleInfo}
                          </div>
                          ${etaInfo}
                        </div>
                    </div>`;
    return content;
  }

  assignDriver(driverDetails) {
    let message = '';

    const isTrue = (driverDetails.canDriverCompleteInputTripInTimeBeforeNextPickup == false || driverDetails.canDriverCompleteInputTripInTimeBeforeNextPickupWithBuffer == false) ? true : false;
    if (driverDetails.dutyStatus == false) {
      this.confirmationService.confirm({
        message: this.commonBindingDataService.getLabel('label_off_duty_confirm'),
        icon: 'pi pi-info-circle',
      accept: () => {
          this.assignDriverApi(driverDetails);
        }
      });
    } else if (driverDetails.bookingWillCompleteInSameShiftSlot != "yes") {
      this.confirmationService.confirm({
        message: this.commonBindingDataService.getLabel('label_booking_complete_in_shift_slot'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.assignDriverApi(driverDetails);
        }
      });
    } else if ((driverDetails.showAlert && (driverDetails?.confirmationMessage != '' || null || undefined)) || isTrue) {
      if ((driverDetails.showAlert && (driverDetails?.confirmationMessage != '' || null || undefined)) && isTrue) {
        message = `The selected driver will not arrive on time for pickup, and it is estimated that if you assign this trip to the selected driver, the driver will not arrive on time for pickup of the next trip <strong>${driverDetails.nextUpcomingTripTripId}</strong>. Do you want to continue?`;
      } else if ((driverDetails.showAlert && (driverDetails?.confirmationMessage != '' || null || undefined))) {
        message = driverDetails?.confirmationMessage;
      } else {
        message = `If you assign this booking the driver may be late for pickup of their existing booking <strong>${driverDetails.nextUpcomingTripTripId}</strong>. Do you wish to continue?`
      }

      this.confirmationService.confirm({
        message: message,
        icon: 'pi pi-info-circle',
        accept: () => {
          this.assignDriverApi(driverDetails);
        }
      });
    } else {
      this.confirmationService.confirm({
        message: `Driver expected to fulfil booking. Pickup Time ${this.datePipe.transform(this.tourBookingInfo.pickupDateTime, 'HH:mm')}; Driver ETA (no buffer) ${driverDetails.estimatedArrivalDateTimeAtPickup ? this.datePipe.transform(driverDetails.estimatedArrivalDateTimeAtPickup, 'HH:mm ') : 'NA'}. Do you wish to continue?`,
        icon: 'pi pi-info-circle',
        accept: () => {
          this.assignDriverApi(driverDetails);
        }
      });
    }
  }

  assignDriverApi(driverDetails) {
    const newDriverId = driverDetails.driverId;
    const isAssigned = (this.tourBookingInfo.driverId) ? true : false;
    const payload: any = {
      tourIdOrTripId: this.tourBookingInfo.id,
      driverIdOrCode: newDriverId,
      reassigned: isAssigned,
      overridden: false
    };

    if (this.dedicatedTourDaywiseDataId) {
      payload.dedicatedTourDaywiseDataId = this.dedicatedTourDaywiseDataId;
    }

    this.commonBindingDataService.driverAssigned(payload).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.sideBarHide.emit();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }
}
